import gql from 'graphql-tag'

export default gql`
mutation($types : String){
    updateAllrunnerAnywhereReport(types : $types)
}
`